import Bloodhound from 'corejs-typeahead'

export const PreventDefault = () => {
    return {
        restrict: 'C',
        link: (scope, element) => {
            $(element).click((event) => {
                event.preventDefault();
            });
        }
    };
};

export const SearchAllChecklistsTypeahead = () => {
    return {
        restrict: 'C',
        link: (scope, element) => {
            const minLength = 3;
            const checklists = new Bloodhound({
                queryTokenizer: Bloodhound.tokenizers.nonword,
                datumTokenizer: Bloodhound.tokenizers.obj.nonword('value'),
                remote: {
                    url: '/api/search/checklists?type=all&mode=typeahead&search=%QUERY',
                    wildcard: '%QUERY',
                    transform: data => {
                        return _.map(data.checklists, checklist => {
                            const parts = checklist.url.split('/');
                            return {
                                value: parts.join(" "),
                                url: checklist.url
                            }
                        });
                    }
                }
            });
            element.typeahead({
                minLength: minLength,
                highlight: true
            }, {
                source: checklists,
                display: 'value',
                limit: 10,
                templates: {
                    suggestion: result => {
                        return "<a href='/" + result.url + "'>" + result.value + "</a>";
                    },
                    notFound: meta => {
                        if (meta.query.length > minLength) {
                            return '<span style="padding: 3px 20px; line-height: 1.5;">No matching Checklists found</span';
                        }
                    }
                }
            });
        }
    };
};

export const Age = () => {
    return {
        restrict: 'C',
        scope: {
            ageDays: '=',
            ageFlag: '='
        },
        link: (scope, element) => {
            const displayAge = () => {
                if (scope.ageDays == 1) {
                    element.html(scope.ageDays + " day");
                } else if (scope.ageDays > 1) {
                    element.html(scope.ageDays + " days");
                } else {
                    element.html("less than a day");
                }
                let cssClass = '';
                if (scope.ageFlag == 'red') {
                    cssClass = "badge-danger"
                } else if (scope.ageFlag == 'orange') {
                    cssClass = "badge-warning"
                } else {
                    cssClass = "badge-success"
                }
                element.addClass(cssClass);
            };
            scope.$watchGroup(['ageDays', 'ageFlag'], () => {
                displayAge();
            });
        }
    };
};

export const LogInForm = ['Organisation', '$q', (Organisation, $q) => {
    return {
        restrict: 'C',
        link: (scope, element, attr) => {
            const form = element;
            const protocol = window.location.protocol;
            const host = window.location.hostname;
            const path = '/login';
            form.on('submit', function(event) {
                event.preventDefault();
                const form = this;
                const email = $("input[name='username']").val();
                Organisation.get({email: email}, data => {
                    if (data.status === 'ok' && data.organisation) {
                        let hostParts = host.split('.').reverse();
                        let orgHost = [data.organisation, hostParts[1], hostParts[0]].join('.');
                        attr.$set('action', protocol + '//' + orgHost + path);
                    }
                    form.submit();
                });
            });
        }
    };
}];

export const ConfirmCheckbox = () => {
    return {
        restrict: 'C',
        link: (scope, element) => {
            const message = "Are you sure?";
            const el = $('input', element);
            el.click(() => {
                if (window.confirm(message)) {
                    // continue;
                } else {
                    return false;
                }
            });
        }
    };
};

/**
 * Use $scope.unsavedWarningMode "assisted" | "default"
 */
export const WarnBeforeClose = () => {
    return {
        restrict: 'C',
        link: (scope, element) => {
            let changed = false;
            $('input, textarea', element).change(event => {
                changed = true;
            });
            $('form', element).submit(event => {
                changed = false;
            });
            const isDirty = () => {
                let dirty = false;
                if (scope.unsavedWarningMode === 'assisted') {
                    dirty = scope.status.unsaved;
                } else {
                    dirty = changed;
                }
                return dirty;
            };
            $(window).bind('beforeunload', function() {
                if (!isDirty()) {
                    return undefined;
                }
                return 'There are unsaved changes on this page. Are you sure you want to close the tab?';
            });
        }
    };
};

export const ConvertToNumber = () => {
    return {
        require: 'ngModel',
        link: (scope, element, attrs, ngModel) => {
            ngModel.$parsers.push((val) => {
                return val ? parseInt(val, 10) : null;
            });
            ngModel.$formatters.push((val) => {
                return val ? '' + val : '0';
            });
        }
    };
};

export const BtnAddHeaderField = () => {
    return {
        restrict: 'C',
        link: (scope, element) => {
            $(element).click((event) => {
                event.preventDefault();
                scope.$apply(() => {
                    scope.definition.headers.push({});
                });
            });
        }
    };
};

export const BtnAddItem = () => {
    return {
        restrict: 'C',
        link: (scope, element) => {
            $(element).click((event) => {
                event.preventDefault();
                const signeeRole = scope.getDefaultNewItemRole();
                if (_.isEmpty(signeeRole)) {
                    alert('Please select a role first');
                } else {
                    scope.$apply(() => {
                        scope.definition.items.push({
                            signeeRole: scope.getDefaultNewItemRole()
                        });
                        scope.toggles.items.push(true);
                    });
                }
            });
        }
    };
};

export const BtnAdd20Items = () => {
    return {
        restrict: 'C',
        link: (scope, element) => {
            $(element).click((event) => {
                event.preventDefault();
                const signeeRole = scope.getDefaultNewItemRole();
                if (_.isEmpty(signeeRole)) {
                    alert('Please select a role first');
                } else {
                    scope.$apply(() => {
                        for (let i = 0; i < 20; i++) {
                            scope.definition.items.push({
                                signeeRole: scope.getDefaultNewItemRole()
                            });
                            scope.toggles.items.push(true);
                        }
                    });
                }
            });
        }
    };
};

export const BtnBulkAddToggle = () => {
    return {
        restrict: 'C',
        link: (scope, element) => {
            $(element).click(() => {
                if (scope.toggles.bulk_add) {
                    scope.$apply(() => {
                        scope.bulkAdd.role = {};
                        scope.toggles.bulk_add = !scope.toggles.bulk_add;
                    });
                } else {
                    const signeeRole = scope.getDefaultNewItemRole();
                    if (_.isEmpty(signeeRole)) {
                        alert('Please select a role first');
                    } else {
                        scope.$apply(() => {
                            scope.bulkAdd.role = signeeRole;
                            scope.toggles.bulk_add = !scope.toggles.bulk_add;
                        });
                    }
                }
            });
        }
    };
};

export const BtnBulkAdd = () => {
    return {
        restrict: 'C',
        link: (scope, element) => {
            $(element).click(() => {
                scope.$apply(() => {
                    const contentsElement = $('.bulk-add');
                    const lines = contentsElement.val().match(/[^\r\n]+/g);
                    if (lines && lines.length) {
                        for (let i = 0; i < scope.definition.items.length; i++) {
                            if (scope.definition.items[i].hasOwnProperty('title') == false) {
                                scope.definition.items.splice(i, 1);
                                i--;
                            }
                        }
                        for (let i = 0; i < lines.length; i++) {
                            scope.definition.items.push({
                                title: lines[i],
                                signeeRole: scope.bulkAdd.role
                            });
                        }
                    }
                    scope.bulkAdd.role = {};
                    scope.toggles.bulk_add = false;
                    contentsElement.val('');
                });
            });
        }
    };
};

export const ClickPrimarySaveButton = () => {
    return {
        restrict: "C",
        link: (scope, element) => {
            $(element).click(() => {
                $("#primary-save-button").click();
            });
        }
    };
};

export const ClickSecondarySaveButton = () => {
    return {
        restrict: "C",
        link: (scope, element) => {
            $(element).click(() => {
                $("#secondary-save-button").click();
            });
        }
    };
};

export const RolesSelection = () => {
    return {
        restrict: 'C',
        link: (scope, element) => {
            $('input', element).each((key, input) => {
                if ($(input).is(':checked')) {
                    const id = $(input).val();
                    scope.roles.push(id);
                }
            });
            $('input', element).change(event => {
                const that = $(event.target);
                const id = that.val();
                if (that.is(':checked')) {
                    scope.$apply(() => {
                        scope.roles.push(id);
                    });
                } else {
                    scope.$apply(() => {
                        const index = scope.roles.indexOf(id);
                        index > -1 && scope.roles.splice(index, 1);
                    });
                }
            });
        }
    };
};

export const FullTitle = () => {
    return {
        restrict: 'C',
        link: (scope, element, attr) => {
            const parts = attr.url.split('/');
            element.replaceWith(parts.join(" "));
        }
    }
};

export const ExclusivePopover = () => {
    return {
        restrict: 'C',
        link: (scope, element) => {
            $(element).click(event => {
                $('[data-toggle="popover"]').not(element).popover('hide');
                $('.exclusive-popover').not(element).popover('hide');
                $(element).popover('toggle');
                event.stopPropagation();
            });
        }
    }
};

export const HelpPanelStick = () => {
    return {
        restrict: 'C',
        link: (scope, element) => {
            $(element).prev().append(element);
        }
    }
};

export const SubdomainPrefill = () => {
    return {
        restrict: 'C',
        link: (scope, element, attr) => {
            const nameParam = attr.nameParam;
            const nameInputSelector = "input[name='" + nameParam + "']";
            const subdomainInputSelector = "input[name='subdomain']";
            $(nameInputSelector).keyup(() => {
                const val = $(nameInputSelector).val();
                if (val !== undefined) {
                    let subdomain = val.toString().toLowerCase().trim();
                    subdomain = subdomain.replace(/[^a-z0-9\s-]/g, ' ');
                    subdomain = subdomain.replace(/[\s-]+/g, '-');
                    subdomain = subdomain.substring(0, 63);
                    element.val(subdomain);
                    scope.$apply(() => {
                        scope.subdomain = subdomain;
                    })
                }
            });
            if (scope.hasOwnProperty('checkSubdomainAvailability')) {
                const checkAvailability = () => {
                    const subdomain = $(subdomainInputSelector).val();
                    scope.checkSubdomainAvailability(subdomain);
                };
                $(subdomainInputSelector).keyup(checkAvailability);
                $(nameInputSelector).keyup(checkAvailability);
            }
        }
    }
};

export const DefinitionTitlePrefill = () => {
    return {
        restrict: 'C',
        link: (scope, element, attr) => {
            const titleInputSelector = "input[name='" + attr.titleParam + "']";
            if (scope.hasOwnProperty('checkTitleAvailability') || scope.$parent.hasOwnProperty('checkTitleAvailability')) {
                const checkAvailability = () => {
                    const val = $(titleInputSelector).val();
                    scope.checkTitleAvailability(val);
                };
                $(titleInputSelector).keyup(checkAvailability);
            }
        }
    }
};

export const DragToScroll = () => {
    return {
        restrict: 'C',
        link: (scope, element) => {
            let stop = true;
            const scroll = step => {
                const scrollY = $(window).scrollTop();
                $(window).scrollTop(scrollY + step);
                if (!stop) {
                    setTimeout(function () { scroll(step) }, 20);
                }
            };
            element.on("drag", event => {
                stop = true;
                if (event.originalEvent.clientY < 150) {
                    stop = false;
                    scroll(-1)
                }
                if (event.originalEvent.clientY > ($(window).height() - 150)) {
                    stop = false;
                    scroll(1)
                }
            });
            element.on("dragend", event => {
                stop = true;
            });
        }
    };
};

export const OkPassword = ['zxcvbn', (zxcvbn) => {
    return {
        restrict: 'AC',
        require: 'ngModel',
        link: (scope, element, attrs, ngModelCtrl) => {
            $(element).on('blur change keydown', () => {
                scope.$evalAsync((scope) => {
                    const pwd = scope.password = element.val();
                    scope.passwordStrength = pwd ? (pwd.length > 8 && zxcvbn.score(pwd) || 0) : null;
                    ngModelCtrl.$setValidity('okPassword', scope.passwordStrength >= 1);
                });
            });
        }
    };
}];

export const CommentModal = () => {
    return {
        restrict: 'C',
        link: (scope, element, attr) => {
            $('.btn-primary', element).click(event => {
                const checklistId = scope.commentModalProps.checklistId;
                const itemId = scope.commentModalProps.itemId;
                const comment = $('textarea', element).val();
                scope.saveComment(checklistId, itemId, comment);
                element.modal('hide');
            });
            $('.btn-secondary', element).click(event => {
                element.modal('hide');
            });
            $(element).on('hide.bs.modal', event => {
                $('textarea', element).val('');
                scope.commentModalProps = {};
            });
        }
    }
    ;
};

export const AutoHideFlash = ['$timeout', ($timeout) => {
    return {
        restrict: 'C',
        link: (scope, element) => {
            $timeout(() => {
                element.addClass('d-none');
            }, 4 * 1000);
        }
    };
}];